const isRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const optionalStrings = (value, keys) => {
  if (!isRecord(value)) return {};
  return Object.fromEntries(keys
    .filter((key) => typeof value[key] === "string" && value[key].trim())
    .map((key) => [key, value[key].trim()]));
};

export function resolveBranding(value) {
  const source = isRecord(value) ? value : {};
  const platform = isRecord(source.platform) ? source.platform : {};
  return {
    platform: {
      name: typeof platform.name === "string" && platform.name.trim() ? platform.name.trim() : "HACaMS",
      ...optionalStrings(platform, ["tagline", "logo"]),
    },
    deployment: optionalStrings(source.deployment, ["name", "descriptor", "tagline", "banner", "logo"]),
    attribution: optionalStrings(source.attribution, ["text"]),
  };
}
